import { storeRequestPromise } from './idb.js';
export class IDBService {
    constructor(db) {
        this.db = db;
        this.createTransaction = (storeNames, mode) => {
            return this.db.transaction(storeNames, mode);
        };
        this.run = async (storeName, getRequest, mode = 'readonly', transaction) => {
            const tx = transaction || this.db.transaction(storeName, mode);
            const store = tx.objectStore(storeName);
            const request = getRequest(store);
            return storeRequestPromise(request);
        };
        this.runAll = async (storeName, getRequests, mode = 'readonly', transaction) => {
            const tx = transaction || this.db.transaction(storeName, mode);
            const store = tx.objectStore(storeName);
            const requests = getRequests(store);
            return Promise.all(requests.map(storeRequestPromise));
        };
        this.iterate = async (storeName, getRequest, iterator, mode = 'readonly', transaction) => {
            const tx = transaction || this.db.transaction(storeName, mode);
            const store = tx.objectStore(storeName);
            const request = getRequest(store);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    const cursor = request.result;
                    if (cursor) {
                        iterator(cursor.value, store);
                        cursor.continue();
                    }
                    else {
                        resolve();
                    }
                };
                request.onerror = reject;
            });
        };
        this.clear = (storeName) => {
            return this.run(storeName, (store) => store.clear(), 'readwrite');
        };
    }
}
//# sourceMappingURL=IDBService.js.map